export function setComments (state, comments) {
  state.comments = comments
}

export function setFormFields (state, formFields) {
  state.formFields = formFields
}
